import { render } from "./view-popup.vue?vue&type=template&id=2471a315"
import script from "./view-popup.vue?vue&type=script&lang=js"
export * from "./view-popup.vue?vue&type=script&lang=js"

import "./view-popup.vue?vue&type=style&index=0&id=2471a315&lang=scss"
script.render = render

export default script